export type TeraTypeOption = {
  id: number;
  name: string;
};

export const TERA_TYPE_OPTIONS: TeraTypeOption[] = [
  { id: 0, name: 'なし' },
  { id: 1, name: 'ノーマル' },
  { id: 2, name: 'かくとう' },
  { id: 3, name: 'ひこう' },
  { id: 4, name: 'どく' },
  { id: 5, name: 'じめん' },
  { id: 6, name: 'いわ' },
  { id: 7, name: 'むし' },
  { id: 8, name: 'ゴースト' },
  { id: 9, name: 'はがね' },
  { id: 10, name: 'ほのお' },
  { id: 11, name: 'みず' },
  { id: 12, name: 'くさ' },
  { id: 13, name: 'でんき' },
  { id: 14, name: 'エスパー' },
  { id: 15, name: 'こおり' },
  { id: 16, name: 'ドラゴン' },
  { id: 17, name: 'あく' },
  { id: 18, name: 'フェアリー' },
  { id: 19, name: 'ステラ' },
];

export const TERA_TYPE_OPTIONS_WITHOUT_NONE: TeraTypeOption[] = TERA_TYPE_OPTIONS.filter((type) => type.id !== 0);
